"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIssuesPath = exports.getEnvValue = void 0;
var _constants = require("./constants");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
const getEnvValue = key => {
  const env = (0, _acsScWebPlatformApi.getEnv)();
  if (_constants.ENV_CONFIGS && _constants.ENV_CONFIGS[env] && _constants.ENV_CONFIGS[env].hasOwnProperty(key)) {
    return _constants.ENV_CONFIGS[env][key];
  } else {
    throw new Error("Cannot find env config for env: ".concat(env, " and key: ").concat(key));
  }
};
exports.getEnvValue = getEnvValue;
const getIssuesPath = () => getEnvValue("ISSUES");
exports.getIssuesPath = getIssuesPath;
//# sourceMappingURL=config.js.map